export const environment = {
  production: true,
  buildId: '4204574548525081',
  configFile: 'config.json',
};
